export const SET_NOTICE = "SET_NOTICE";
export const CLEAR_NOTICE = "CLEAR_NOTICE";
